import { render, staticRenderFns } from "./KBottomAppBar.vue?vue&type=template&id=2316558a&scoped=true&"
import script from "./KBottomAppBar.vue?vue&type=script&lang=js&"
export * from "./KBottomAppBar.vue?vue&type=script&lang=js&"
import style0 from "./KBottomAppBar.vue?vue&type=style&index=0&id=2316558a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316558a",
  null
  
)

export default component.exports